import { Component, EventEmitter, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { UserEntryRecord } from 'src/app/models/human-resources/user-entry-record';
import { EndpointDictionary } from 'src/app/utils/endpoints-dictionary';
import {
  HeaderFilters,
  HttpService,
  MenuBreadCrumb,
  MessageService,
  params,
  SessionService,
  TableColumns,
  TableConfiguration,
} from 'brainloper-ui';

@Component({
    selector: 'app-user-entry-record',
    templateUrl: './user-entry-record.component.html',
    styleUrls: ['./user-entry-record.component.scss'],
    standalone: false
})
export class UserEntryRecordComponent implements OnInit {
  public EndpointDictionary = EndpointDictionary;
  public selected = new FormControl(0);
  public body: UserEntryRecord;
  public isEdit: boolean = false;
  public isExit: boolean = false;
  public isIncome: boolean = false;
  public label: string;

  public menuBreadCrumb: Array<MenuBreadCrumb> = [
    {
      name: 'Inicio',
      router: '/inicio',
    },
    {
      name: 'Registro',
      current: true,
    },
  ];

  params: params[] = [];
  reloadTableEntryRecord = new EventEmitter<any>();
  configurationEntryRecord: TableConfiguration = {
    primaryKey: 'id',
    edit: true,
    selectable: false,
    editPer: true,
    income: true,
    exit: true,
    hideTitle: true,
    exportXslx: true,
  };
  columnasEntryRecord: TableColumns<UserEntryRecord>[] = [
    {
      ID: 'userName',
      label: 'Usuario',
      type: 'string',
      style: {
        textAlign: 'center',
      },
    },
    {
      ID: 'entryDate',
      label: 'Fecha ingreso',
      type: 'dateWithTime',
      style: {
        textAlign: 'center',
      },
    },
    {
      ID: 'exitDate',
      label: 'Fecha salida',
      type: 'dateWithTime',
      style: {
        textAlign: 'center',
      },
    },
    {
      ID: 'totalHours',
      label: 'Duración Total (hh:mm)',
      type: 'number',
      style: {
        textAlign: 'center',
        movil: 'no-movil'
      },
    },
    {
      ID: 'userRegisterdName',
      label: 'Usuario registra',
      type: 'string',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
    },
  ];

  headerFileXlsm: Array<params> = [
    { id: 'userName', value: 'Usuario' },
    { id: 'entryDate', value: 'Fecha Ingreso' },
    { id: 'exitDate', value: 'Fecha Salida' },
    { id: 'userRegisterdName', value: 'Usuario Registra' },
    { id: 'totalHours', value: 'Total Horas' },
  ];

  headerFilters: Array<HeaderFilters> = [
    {
      tN: 'uri',
      labelFilter: 'Usuario',
      urlData: EndpointDictionary.User.USER_COMBO,
      visibleField: 'name',
      primaryKey: 'userId',
      type: 'select',
      value: '',
      fileNameDb: 'id_usuario',
    },
    {
      tN: 'uri',
      labelFilter: 'Registra',
      urlData: EndpointDictionary.User.USER_COMBO,
      visibleField: 'name',
      primaryKey: 'userId',
      type: 'select',
      value: '',
      fileNameDb: 'id_usuario_registra',
    },

    {
      tN: 'uri',
      labelFilter: 'Fecha Ingreso',
      visibleField: 'fecha_ingreso',
      type: 'date',
      value: '',
    },
    {
      tN: 'ao',
      labelFilter: 'Fecha Salida',
      visibleField: 'fecha_salida',
      type: 'date',
      value: '',
    },
    {
      tN: 'uri',
      labelFilter: 'Fecha Inicio Entre',
      visibleField: 'fecha_ingreso',
      type: 'dateRange',
      value: '',
    },
    {
      tN: 'uri',
      labelFilter: 'Fecha Fin Entre',
      visibleField: 'fecha_salida',
      type: 'dateRange',
      value: '',
    },
  ];

  constructor(
    private session: SessionService,
    private http: HttpService,
    private message: MessageService) {}

  ngOnInit(): void {}

  incomeUserRegister($event: number) {
    this.isExit = false;
    this.isIncome = true;
    this.label = 'Crear Registro de Usuario';
    this.selected.setValue(1);
  }

  exitUserRegister($event: number) {
    this.isExit = true;
    this.label = 'Completar Registro de Usuario';
    this.selected.setValue(1);
  }

  async editarUserRegister($event: UserEntryRecord[]) {
    this.message.openLoading('Cargando', 'Cargando Registro de Usuario');
    let res: UserEntryRecord = await this.http.getDataBody(
      `${EndpointDictionary.userEntryRecord.CRUD_USER_ENTRY_RECORD}/${$event[0].id}`
    );
    if (res) {
      this.isEdit = true;
      this.body = res;
      this.label = 'Editar Registro';
      this.selected.setValue(1);
    }
    this.message.closeLoading();
  }

  completeRegister(reloadTable: boolean = true) {
    this.selected.setValue(0);
    if(reloadTable)
      this.reloadTableEntryRecord.emit();
  }

  selectedTab($event) {
    this.selected.setValue($event.index);
    if ($event.index == 0) {
      this.isEdit = false;
      this.isExit = false;
      this.isIncome = false;
    }
  }
}
